import React, { useState } from 'react';
import { Button, Container, FormControl, InputLabel, Box, Modal, Tooltip, MenuItem, Select, AppBar, Toolbar, Paper, TextField, Typography } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';

const AddCity = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [countryId, setCountryId] = useState('');
  const [stateId, setStateId] = useState('');
  const [city, setCity] = useState('');
  const navigate = useNavigate();

  // Static data for countries and states
  const staticCountryData = [
    { countryId: 1, countryName: 'India' },
  ];

  const staticStateData = [
    { stateId: 1, stateName: 'Bihar' },
    { stateId: 2, stateName: 'Jharkhand' },
  ];

  const handleSave = (e) => {
    e.preventDefault();
    if (city && countryId && stateId) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
    setCountryId('');
    setCity('');
    setStateId('');
  };

  return (
    <Container>
     <Box
          sx={{
            backgroundColor: 'rgba(2, 78, 101, 1)', // dark navy blue
            padding: '12px 16px',
            boxShadow: 3,
            borderRadius: '4px 4px 0 0',
            margin: '0 auto',
           width: "100%",
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
        Add City
      </Typography> </Box>

      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor:'#f8fdfeff' }}>
        <div>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel htmlFor="country">Country:</InputLabel>
            <Select
              id="country"
              autoFocus
              value={countryId}
              label="Country"
              onChange={(e) => setCountryId(e.target.value)}
            >
              {staticCountryData.map((countryItem) => (
                <MenuItem key={countryItem.countryId} value={countryItem.countryId}>
                  {countryItem.countryName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel htmlFor="state">State:</InputLabel>
            <Select
              id="state"
              value={stateId}
              label="State"
              onChange={(e) => setStateId(e.target.value)}
            >
              {staticStateData.map((stateItem) => (
                <MenuItem key={stateItem.stateId} value={stateItem.stateId}>
                  {stateItem.stateName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="City Name"
            variant="outlined"
            fullWidth
            value={city}
            onChange={(e) => setCity(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!countryId && "Select Country" || !stateId && "Select State" || !city && "Enter City Name"} arrow>
            <span>
              <Button
                variant="contained"
               
                onClick={handleSave}
                sx={{ mr: 2, 
                     backgroundColor: '#127498ff',
                '&:hover': { backgroundColor: '#116280ff' }
                 }}
                disabled={!city || !countryId || !stateId}
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              City Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              City Added Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddCity;